import React from 'react';
import classNames from 'classnames';

const options = [
  {
    type: 'RdStationInput',
    className: 'rd-station-input',
    title: 'Informação do lead',
    name: 'Campo',
    iconSrc: '/assets/images/icons/builder/bloco_campo_rd.svg',
  },
  {
    type: 'RdStationSubmitLead',
    className: 'rd-station-submit-lead',
    title: 'Cria um lead',
    name: 'Cria Lead',
    iconSrc: '/assets/images/icons/builder/bloco_criar_lead.svg',
  },
];

const SubMenuRDStation = (props) => {
  const { draggingType, handleDragStart, handleDragEnd } = props;

  const renderItems = () => {
    return options.map(({ type, className, title, iconSrc, name }) => {
      return (
        <li key={type}>
          <span
            className={classNames({
              'd-none': draggingType !== type,
              'dragging-overlay': true,
            })}
            style={{ height: 82 }}
          />
          <input
            id={`radio_avancado--${className}`}
            type="radio"
            name="radio_blocos_padrao"
          />
          <label
            htmlFor={`radio_avancado--${className}`}
            draggable
            onDragStart={(e) => handleDragStart(e, type)}
            onDragEnd={(e) => handleDragEnd(e)}
            className={classNames({
              dragging: draggingType === type,
            })}
          >
            <img
              src="/assets/images/icons/icon_hint.svg"
              className="hint"
              data-toggle="tooltip"
              data-placement="right"
              title={title}
              alt=""
            />
            <img className="no-drag" src={iconSrc} alt="" />
            <p>{name}</p>
          </label>
        </li>
      );
    });
  };

  return (
    <ul className="collapse multi-collapse" id="integracao-rd-station">
      {renderItems()}
    </ul>
  );
};

export default SubMenuRDStation;
